// React
import { useEffect, useRef, useState } from "react";

// Router
import { useLocation, useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { ownerAccountsViewAll } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources";
import {
  approveFieldForceRequest,
  getAllFieldForceRequest,
  resetToggleFfReq,
  setToggleFfReq,
} from "../../../redux/features/fieldForceRequest";

// Utils
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import useCategories from "../../../utils/useCategories";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat";
import { getAllFieldForceAccount } from "../../../redux/features/accounts/fieldForceAccount";

// Components
import Loader from "../../../components/Loader/Index";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithBank from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import ListContainer from "../../../components/_utils/CommonListView/ListContainer";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo";
import SVGComponent from "../../../components/_utils/SVGComponent";
import TickerAnimation from "../../../components/_utils/TickerAnimation";
import ICONS from "../../../assets/Icons";
import useRestrictedAction from "../../../hooks/useRestrictedAction";
import UseHandleScroll from "../../../hooks/useHandleScroll";

const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const FieldForceRequestViewAll = ({
  typepop,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
  closeFfTxnDetailsModal,
  flowType,
  alert,
  isPopupMode,
}) => {
  const isActionRestrictedMode = isPopupMode;
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  // 1️⃣ useDispatch, useNavigate, location
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // 2️⃣ useRef
  const scrollContainerRef = useRef(null);
  const pageSizeChangedRef = useRef(false);

  // 3️⃣ Constants (needed for initial state)
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration?.lengthCheckOne ?? 1,
    pagesize: PaginationConfiguration?.paginationOptions[0],
  });
  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));
  const categoryMapper = useCategories();

  // 4️⃣ useState
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    type === "requestViewallPopup"
      ? dropdownOptions[0]
      : searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    type === "requestViewallPopup"
      ? 1
      : Number(searchParam.get("pageno")) ||
          (GlobalConfiguration?.lengthCheckOne ?? 1),
  );

  const [pageSize, setPageSize] = useState(
    type === "requestViewallPopup"
      ? dropdownOptions[0]
      : searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [mainData, setMainData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [accountnumberstate, setaccountnumberstate] = useState("");
  const [animateViewAll, setAnimateViewAll] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [requestAmountFilter, setRequestAmountFilter] = useState(
    type === "requestViewallPopup"
      ? ""
      : searchParam.get("requested_amount") || "",
  );
  const [fieldForceAmountFilter, setFieldForceAmountFilter] = useState(
    type === "requestViewallPopup"
      ? ""
      : searchParam.get("fieldForceAmount") || "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    type === "requestViewallPopup" ? "" : dateFromUrl.start,
  );
  const [endDateFilter, setEndDateFilter] = useState(
    type === "requestViewallPopup" ? "" : dateFromUrl.end,
  );
  const [currentStatus, setCurrentStatus] = useState(
    type === "requestViewallPopup" && flowType !== "RequestRejectAll"
      ? ""
      : flowType === "RequestRejectAll"
        ? "pending"
        : searchParam.get("status") || "",
  );
  const [accountNumber, setAccountNumber] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState("");
  const [currentCategory, setCurrentCategory] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("category") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat") || categoryName || "",
  );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [ownerAccId, setOwnerAccId] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("ownerAcc") || "",
  );
  const [fieldForceAccId, setFieldForceAccId] = useState(
    type === "requestViewallPopup"
      ? (TxnHistoryid ?? "")
      : searchParam.get("fieldForceAcc") || (TxnHistoryid ? TxnHistoryid : ""),
  );
  const [accountName, setAccountName] = useState(
    TxnHistoryAccountName ? TxnHistoryAccountName : "",
  );
  const [accountNameValue, setAccountNameValue] = useState("");
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchdata, SetsearchData] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("search") || "",
  );
  const [loading, setLoading] = useState(true);

  // 5️⃣ useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const { toggleFfReq, storedPage } = useSelector(
    (state) => state.fieldForceRequest,
  );

  useEffect(() => {
    if (type !== "requestViewallPopup" || !categoryName) return;

    let isMounted = true;
    dispatch(getAllCategories()).then((response) => {
      const category = response?.payload?.categories?.find(
        (item) => item?.name === categoryName,
      );
      if (isMounted && category) {
        setCurrentCategory(category.id);
        setDisplayCategory(category.name);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [categoryName, dispatch, type]);

  // 6️⃣ Callbacks
  const handleSubmit = (key, value) => {
    if (type !== "requestViewallPopup") {
      handleSearchParams(key, value);
    }
  };

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration?.internalTxnCardHoverHeight,
  );

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const resetScrollToTop = () => {
    setDirection("");
    lastScrollTop.current = GlobalConfiguration?.lengthCheckZero;
    const scrollEl = scrollContainerRef.current;
    if (scrollEl) {
      scrollEl.scrollTop = GlobalConfiguration?.lengthCheckZero;
      if (scrollEl.parentElement) {
        scrollEl.parentElement.scrollTop = GlobalConfiguration?.lengthCheckZero;
      }
    }
  };

  const handleSelect = (value) => {
    if (value !== pageSize) {
      pageSizeChangedRef.current = true;
      resetScrollToTop();
    }
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(storedPage) || currentPage;
    setCurrentPage(nextPage);
    if (type !== "requestViewallPopup") {
      handleSearchParams("pagesize", value);
      handleSearchParams("pageno", nextPage);
    }
    setIsOpen(!isOpen);
  };

  const handleAction = async () => {
    setAnimateViewAll(false);
    if (searchUserTextDebounce !== "") {
      setMainData([]);
    }
    if (currentStatus === "require approval") {
      try {
        setLoading(true);

        const responseApproval = await dispatch(
          approveFieldForceRequest({
            page_no: currentPage,
            page_size: pageSize,
            category_id: currentCategory,
          }),
        );

        const newApprovalData = responseApproval?.payload?.requests || [];

        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);
        setTotalBalanceAmount(responseApproval?.payload?.total_amount || 0);
        setLoading(false);
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let queryParams = {
          page_no: currentPage,
          page_item_count:
            flowType === "RequestRejectAll"
              ? PaginationConfiguration.paginationBig
              : pageSize,
        };

        if (searchdata !== "") {
          queryParams.additional_data = searchdata;
        }

        if (ownerAccId && ownerAccId !== "") {
          queryParams.owner_account_id = [ownerAccId];
        }
        if (fieldForceAccId && fieldForceAccId !== "") {
          queryParams.field_force_account_id = fieldForceAccId;
        }

        if (fieldForceAmountFilter) {
          queryParams.approved_amount = fieldForceAmountFilter;
        }

        if (requestAmountFilter) {
          queryParams.requested_amount = requestAmountFilter;
        }

        if (currentCategory !== "") {
          queryParams.category_id = currentCategory;
        }

        if (currentStatus) {
          queryParams.lifecycle_status = currentStatus;
        }

        if (
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration?.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration?.day_in_seconds;
        }

        const response = await dispatch(getAllFieldForceRequest(queryParams));
        setMainData(response?.payload);
        const newData = response?.payload?.requests || [];
        setAccumulatedData(newData);
        setLoading(false);
        setTotalBalanceAmount(Number(response?.payload?.total_amount || 0));
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
        setTotalBalanceAmount(0);
      }
    }
  };

  // 7️⃣ useEffect
  useEffect(() => {
    handleAction();
  }, [
    currentPage,
    pageSize,
    currentStatus,
    startDateFilter,
    endDateFilter,
    accountnumberstate,
    ownerAccId,
    fieldForceAccId,
    searchdata,
    currentCategory,
    requestAmountFilter,
    fieldForceAmountFilter,
    markerData,
  ]);

  useEffect(() => {
    if (loading || !pageSizeChangedRef.current) return;
    pageSizeChangedRef.current = false;
    resetScrollToTop();
  }, [loading]);

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration?.intervalMedium,
    );

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      const startTs = displayDate(start);
      const endTs = displayDate(end);
      setStartDateFilter(startTs);
      setEndDateFilter(endTs);
      if (type !== "requestViewallPopup") {
        handleSearchParams("date", `${startTs},${endTs}`);
      }
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      if (type !== "requestViewallPopup") {
        handleSearchParams("date", "");
      }
    }
  };

  const onMount = () => {
    setCurrentPage(1);
    dispatch(resetToggleFfReq());
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  const handlePagination = (page) => {
    resetScrollToTop();
    setCurrentPage(page);
    if (type !== "requestViewallPopup") {
      handleSearchParams("pageno", page);
    }
  };

  const fetchData = async () => {
    setDataLoading(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Search":
          if (searchUserTextDebounce === "") {
            SetsearchData("");
          } else {
            SetsearchData(searchUserTextDebounce);
          }
          setDataLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response?.payload?.owner_accounts?.map((itm) => ({
                id: itm?.id,
                Account_number: itm?.bank_acc_no,
                display: itm?.bank_acc_no,
                Name: itm?.name,
                IFSC_code: itm?.ifsc_code,
                Email_ID: itm?.email_id,
              })) || [];
          }
          break;

        case "Field force account":
          response = await dispatch(
            getAllFieldForceAccount({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.field_force_accounts?.map((itm) => ({
                id: itm?.id,
                Name: itm?.name,
                Account_number: itm?.bank_acc_no,
                display: itm?.name,
                IFSC_code: itm?.ifsc_code,
                Contact_number: itm?.contact_no,
                Email_ID: itm?.email_id,
              })) || [];
          }
          break;

        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm?.id,
              Category: itm?.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }
    if (toggleFfReq !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar) {
        dispatch(setToggleFfReq(newToggleValue));
      }

      if (type !== "requestViewallPopup") {
        handleSearchParams("pageno", GlobalConfiguration?.lengthCheckOne ?? 1);
      }
    }
  };

  const clearParameterVisibility =
    searchdata ||
    !!currentStatus ||
    !!currentCategory ||
    !!requestAmountFilter ||
    !!fieldForceAmountFilter ||
    !!accountnumberstate ||
    !!ownerAccId ||
    (!!fieldForceAccId && type !== "requestViewallPopup") ||
    !!searchUserTextDebounce ||
    !!(startDateFilter && endDateFilter) ||
    accumulatedData?.length;

  const handleClearParams = (e) => {
    setAnimateViewAll(false);
    e?.stopPropagation();
    const defaultPage = GlobalConfiguration?.lengthCheckOne ?? 1;
    const defaultSize = dropdownOptions[0];
    setCurrentPage(defaultPage);
    setSearchUserTextDebounce("");
    setCurrentCategory("");
    setDisplayCategory("");
    setFieldForceAmountFilter("");
    setRequestAmountFilter("");
    setaccountnumberstate("");
    setOwnerAccId("");
    if (
      (flowType !== undefined && flowType !== "RequestRejectAll") ||
      type !== "requestViewallPopup"
    ) {
      setFieldForceAccId("");
    }
    if (flowType !== "RequestRejectAll") {
      setCurrentStatus("");
    }
    setStartDateFilter("");
    setEndDateFilter("");
    SetsearchData("");
    if (type !== "requestViewallPopup") {
      navigate(
        {
          pathname: location?.pathname,
          search: `?pageno=${defaultPage}&pagesize=${defaultSize}`,
        },
        { replace: true },
      );
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "rejected":
        return "var(--failed)";
      default:
        return "var(--settled)";
    }
  };

  return (
    <div
      id={`${type !== "requestViewallPopup" && "beneScrollContainer"} `}
      className={`bg-primary-bg ${type === "requestViewallPopup" && "h-full"} ${flowType === "RequestRejectAll" && "relative"} flex flex-col webview ${
        typepop === "transactionHistorypopup" ? "h-full-height" : ""
      }`}
    >
      {accumulatedData?.length > GlobalConfiguration?.lengthCheckZero && (
        <div
          className={` ${type === "requestViewallPopup" ? "absolute" : "fixed"} rounded-none ${loading && "hidden"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} bottom-bottom-base w-full  ${
            typepop === "transactionHistorypopup"
              ? "bottom-bottom-base w-full rounded-none Qmd:bottom-bottom-sm Qmd:w-pagination-width Qmd:rounded-b-border-radius-md"
              : "bottom-bottom-base w-full rounded-none"
          }`}
        >
          <div
            className={`${
              (type === "requestViewallPopup" || showInnerSearchBar) &&
              flowType !== "RequestRejectAll" &&
              " bg-PopUp-BackDrop h-full"
            }`}
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
              typePopup={typepop === "transactionHistorypopup"}
            />
          </div>
        </div>
      )}

      {/* Main code start here  */}
      <div
        className={`bg-primary-bg flex ${type === "requestViewallPopup" && "relative"} flex-col  ${
          typepop === "transactionHistorypopup" ||
          type === "requestViewallPopup"
            ? "h-full"
            : "h-screen"
        }`}
        id="benetxnmain"
      >
        <div
          className={` ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"}  bg-primary-nav  ${type === "requestViewallPopup" ? "hidden" : "block"} ${
            typepop !== "requestViewallPopup"
              ? "Qsmd:h-navbar-breadcrumb-height"
              : ""
          } flex-shrink-0`}
        ></div>
        <div
          className={`z-z-index-overlay flex flex-col items-center justify-center Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${typepop === "transactionHistorypopup" || type === "requestViewallPopup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
        >
          <TopNavComponent
            direction={direction}
            topNavHeader={totalBalanceAmount}
            topNavSubText="Total amount"
            handleBack={() => {
              navigate(-1);
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration?.lengthCheckZero
                ? false
                : true
            }
            isToggleNeeded={true}
            toggleProps={{
              state: toggleFfReq,
              title: toggleFfReq ? "Grid View" : "List View",
              isDisabled: false,
              handleClick: () => {
                handleToggle(!toggleFfReq);
              },
            }}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search field force request",
              filterPlaceholder: "Category specific detail",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchdata,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    SetsearchData(val);
                  },
                  isDropdown: false,
                  isDisabled: loading || currentStatus === "require approval",
                },
                {
                  name: "Owner account",
                  short_name: "Own. Acc",
                  isMulti: false,
                  value: ownerAccId,
                  displayValue: standardAccountNumberFormat(
                    accountNumber,
                    true,
                  ),
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setOwnerAccId(val);
                    handleSubmit("ownerAcc", val);
                  },
                  setDisplayValue: setAccountNumber,
                  valueType: "string",
                  isDropdown: true,
                  isDisabled: loading || currentStatus === "require approval",
                },
                {
                  name: "Field force account",
                  short_name: "FF A/c",
                  isMulti: false,
                  value: fieldForceAccId,
                  displayValue:
                    accountName?.toLowerCase() ||
                    accountNameValue?.toLowerCase(),
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setFieldForceAccId(val);
                    handleSubmit("fieldForceAcc", val);
                  },
                  setDisplayValue: (val) => {
                    setAccountName(val);
                    setAccountNameValue(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled:
                    type === "requestViewallPopup"
                      ? true
                      : loading || currentStatus === "require approval",
                },

                {
                  name: "Approved amount",
                  short_name: "Appr Amt - INR",
                  isMulti: false,
                  value: fieldForceAmountFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setFieldForceAmountFilter(val);
                    handleSubmit("fieldForceAmount", val);
                  },
                  displayValue: FormatAmount({
                    price: fieldForceAmountFilter,
                  }),
                  isDropdown: false,
                  isDisabled: loading || currentStatus === "require approval",
                  valueType: "number",
                },

                {
                  name: "Request amount",
                  short_name: "Req Amt - INR",
                  isMulti: false,
                  value: requestAmountFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setRequestAmountFilter(val);
                    handleSubmit("requestAmount", val);
                  },
                  displayValue: FormatAmount({
                    price: requestAmountFilter,
                  }),
                  isDropdown: false,
                  isDisabled: loading || currentStatus === "require approval",
                  valueType: "number",
                },

                {
                  name: "Category",
                  short_name: "Cat",
                  valueType: "string",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setCurrentCategory(val);
                    const categoryName =
                      inputData.find(
                        (category) => String(category?.id) === String(val),
                      )?.Category ?? "";
                    setDisplayCategory(categoryName);
                    handleSubmit("category", val);
                    handleSubmit("dispCat", categoryName);
                  },
                  isDropdown: true,
                  isDisabled:
                    type === "requestViewallPopup" && categoryName
                      ? true
                      : loading
                        ? true
                        : false,
                  displayValue: displayCategory,
                },
              ],
              filters: [
                {
                  name: "Approval status",
                  filterType: "dropdown",
                  variant: "single",
                  value: currentStatus,
                  options: services?.includes("AFieldForceRequest")
                    ? ["approved", "require approval", "pending", "rejected"]
                    : ["approved", "pending", "rejected"],
                  dropdownPlaceHolder:
                    currentStatus === "deleted"
                      ? "Discard"
                      : currentStatus === "rejected"
                        ? "Rejected"
                        : "Select status",
                  isDisabled: flowType === "RequestRejectAll" ? true : false,
                  statusPop: true,
                  handleChange: (val) => {
                    setAnimateViewAll(false);
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setCurrentStatus(val);
                    handleSubmit("status", val);
                  },
                },

                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisabled: currentStatus === "require approval",
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration?.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration?.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    setAnimateViewAll(false);
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    handleFilterDateRange(date);
                  },
                },
              ],

              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                (flowType !== "RequestRejectAll" &&
                  currentStatus?.length >
                    GlobalConfiguration?.lengthCheckZero) ||
                currentCategory?.length ||
                loading
              ),

              isSearchClearAllDisabled: !(
                searchdata?.length ||
                requestAmountFilter?.length ||
                fieldForceAmountFilter?.length ||
                (!(type === "requestViewallPopup" && categoryName) &&
                  currentCategory?.length) ||
                (type !== "requestViewallPopup" &&
                  TxnHistoryAccountName?.length) ||
                (type !== "requestViewallPopup" && fieldForceAccId?.length) ||
                ownerAccId?.length ||
                loading
              ),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loading || dataLoading,
              setLoading: (e) => {},
              isShowFilter: true,
              isShowSortBy: false,
            }}
          />
        </div>
        {/* Card section  */}
        {showInnerSearchBar && (
          <div class="absolute bg-PopUp-BackDrop opacity-light-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
        )}
        <div
          id="benetxnViewallScrollContainer"
          className={` flex-1 ${
            showInnerSearchBar
              ? "overflow-y-hidden h-screen opacity-light-opacity bg-PopUp-BackDrop cursor-pointer-none pointer-events-none"
              : !loading && !accumulatedData?.length
                ? "h-screen"
                : "mb-[var(--pagination-height)]"
          } ${loading && accumulatedData?.length ? "overflow-y-hidden mt-margin-md" : !accumulatedData?.length && !loading ? "overflow-hidden" : "overflow-y-auto"}`}
        >
          {loading ? (
            <div className="loader-container m-auto flex items-center justify-center h-full">
              <Loader />
            </div>
          ) : accumulatedData?.length ? (
            <div
              ref={scrollContainerRef}
              className={` overflow-x-hidden flex-1 h-full content-start  ${
                !toggleFfReq
                  ? "standard-card-alignment"
                  : "standard-list-view-alignment"
              } gap-x-gap-sm gap-y-gap-md`}
              onScroll={handleScroll}
            >
              {!toggleFfReq
                ? accumulatedData?.map((transactions) => {
                    return (
                      <CardContainer
                        // hoverHeight={
                        //   transactions?.requested_amount
                        //     ? GlobalConfiguration.reimbursementRequestCardHoverHeightWithAmount
                        //     : GlobalConfiguration?.reimbursementRequestCardHoverHeightWithoutAmount
                        // }
                        hoverHeight={
                          GlobalConfiguration?.reimbursementTxnMultiApprovalCardHoverHeight
                        }
                        filterRef={scrollContainerRef}
                        // minHeight={GlobalConfiguration?.BeneTxnCardMinHeight}
                        key={transactions?.request_id}
                        onClickHandler={() => {
                          const options =
                            transactions?.lifecycle_status === "pending" &&
                            services?.includes("AFieldForceRequest")
                              ? {
                                  state:
                                    currentStatus === "require approval"
                                      ? "require approval"
                                      : transactions?.lifecycle_status,
                                }
                              : {};
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (
                              isActionRestrictedMode ||
                              alert === "alertpopup"
                            ) {
                              actionRestricted();
                            } else {
                              navigate(
                                `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${transactions?.request_id}`,
                                {
                                  state: {
                                    isViewAll:
                                      location?.pathname?.includes("view_all"),
                                    options: options,
                                  },
                                },
                              );
                            }

                            if (
                              type === "requestViewallPopup" &&
                              typeof closeFfTxnDetailsModal === "function"
                            ) {
                              closeFfTxnDetailsModal();
                            }
                          }
                        }}
                        isDisabled={showInnerSearchBar}
                      >
                        <card-body>
                          <TextWithIcon
                            type="Amount"
                            fontWeight="semibold"
                            text={transactions?.requested_amount}
                            subText="Requested amount"
                            textColor={
                              transactions?.approved_amount ===
                              transactions?.requested_amount
                                ? "var(--text-primary)"
                                : "var(--queued)"
                            }
                          />
                          {transactions?.approved_amount ? (
                            <TextWithIcon
                              type={"Amount"}
                              fontWeight="semibold"
                              text={transactions?.approved_amount}
                              subText="Approved amount"
                              textColor="var(--settled)"
                            />
                          ) : (
                            <TextWithIcon
                              type={"text"}
                              fontWeight="normal"
                              text={"N/A"}
                              subText="Approved amount"
                              textColor="var(--text-primary)"
                            />
                          )}

                          <TextWithIcon
                            text={
                              transactions?.field_force_account_name || "N/A"
                            }
                            type="Text"
                            subText="Requested by"
                            fontWeight="normal"
                            textColor="var(--text-primary)"
                          />

                          <TextWithBank
                            text={
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"
                            }
                            subText={"Status"}
                            type="Text"
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={
                              transactions?.lifecycle_status === "N/A"
                                ? "var(--text-primary)"
                                : getStatusColor(transactions?.lifecycle_status)
                            }
                            src={
                              categoryMapper(
                                transactions?.category_id?.category_id,
                              )?.url
                            }
                            imgColor={
                              categoryMapper(
                                transactions?.category_id?.category_id,
                              )?.colour
                            }
                            ifscCode={
                              transactions?.field_force_account_ifsc_code
                            }
                          />
                        </card-body>
                      </CardContainer>
                    );
                  })
                : accumulatedData?.map((transactions) => {
                    return (
                      <ListContainer
                        hoverHeight={
                          GlobalConfiguration?.reimbursementRequestListHoverHeight
                        }
                        key={transactions?.request_id}
                        filterRef={scrollContainerRef}
                        onClickHandler={() => {
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (
                              isActionRestrictedMode ||
                              alert === "alertpopup"
                            ) {
                              actionRestricted();
                            } else {
                              navigate(
                                `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${transactions?.request_id}`,
                                {
                                  state: {
                                    isViewAll:
                                      location?.pathname?.includes("view_all"),
                                  },
                                },
                              );
                              if (
                                type === "requestViewallPopup" &&
                                typeof closeFfTxnDetailsModal === "function"
                              ) {
                                closeFfTxnDetailsModal();
                              }
                            }
                          }
                        }}
                      >
                        <list-body>
                          <div className="w-full flex justify-between pr-padding-sm py-padding-sm gap-x-gap-sm">
                            <div
                              className={`flex flex-col gap-y-gap-sm w-full`}
                            >
                              <div className="w-full flex gap-x-gap-sm">
                                <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                                  <div className="flex gap-x-gap-sm items-center">
                                    <CommonBankLogo
                                      variant="small"
                                      ifsc={
                                        transactions?.field_force_account_ifsc_code
                                      }
                                    />
                                    <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                                    <SVGComponent
                                      url={
                                        categoryMapper(
                                          transactions?.category_id
                                            ?.category_id,
                                        )?.url
                                      }
                                      color={
                                        categoryMapper(
                                          transactions?.category_id
                                            ?.category_id,
                                        )?.colour
                                      }
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                    />
                                  </div>
                                </div>
                                <p className="overflow-hidden whitespace-nowrap overflow-ellipsis items-center text-settled text-font-xs flex-1 flex font-semibold ">
                                  <span>
                                    {(shouldBeRedacted(
                                      transactions?.requested_amount,
                                    )
                                      ? ""
                                      : "INR ") +
                                      Number(
                                        transactions?.requested_amount,
                                      )?.toLocaleString("en-IN", {
                                        minimumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                        maximumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                      })}
                                  </span>
                                </p>
                                <div className="border-l border-primary-bg"></div>
                                <div className="flex gap-x-gap-sm justify-end items-center">
                                  <p className="text-text-primary font-normal text-font-xs min-w-standard-account-min-width  text-right">
                                    {transactions?.created_on
                                      ? formatDateViewAll(
                                          transactions?.created_on,
                                          false,
                                          false,
                                        )
                                      : "Not given"}
                                  </p>
                                </div>
                              </div>

                              <div className="w-full pl-padding-sm flex justify-between items-center">
                                <p
                                  className={`text-font-xs flex-1 text-text-primary truncate font-normal`}
                                >
                                  <TickerAnimation
                                    text={
                                      transactions?.field_force_account_name ||
                                      "N/A"
                                    }
                                  />
                                </p>
                              </div>
                            </div>
                          </div>
                        </list-body>

                        <list-hover>
                          <div className="flex items-center justify-between p-padding-sm">
                            <div
                              className={`${transactions?.lifecycle_status === "approved" && "border-r border-primary-bg w-width-md"}  `}
                            >
                              <div className="flex flex-col gap-y-gap-xs min-w-0">
                                <p
                                  className="text-font-xs text-text-primary truncate block whitespace-nowrap overflow-hidden min-w-0 font-normal capitalize"
                                  style={{
                                    color:
                                      transactions?.lifecycle_status === "N/A"
                                        ? "var(--text-primary)"
                                        : getStatusColor(
                                            transactions?.lifecycle_status,
                                          ),
                                    fontWeight: "bold",
                                  }}
                                >
                                  {currentStatus === "require approval"
                                    ? "require approval"
                                    : transactions?.lifecycle_status || "N/A"}
                                </p>

                                <p className="text-font-xxs text-text-secondary">
                                  Status
                                </p>
                              </div>
                            </div>

                            {transactions?.lifecycle_status === "approved" && (
                              <div className="flex flex-col gap-y-gap-xs">
                                <div className="text-settled text-font-xs text-right font-semibold">
                                  {shouldBeRedacted(
                                    transactions?.approved_amount,
                                  )
                                    ? ""
                                    : "INR "}

                                  <FormatAmount
                                    price={Number(
                                      transactions?.approved_amount,
                                    )}
                                  />
                                </div>
                                <div className="text-text-primary text-font-xxs">
                                  Approved amount
                                </div>
                              </div>
                            )}
                          </div>
                        </list-hover>
                      </ListContainer>
                    );
                  })}
            </div>
          ) : (
            <div
              className={`h-full flex-col flex justify-center items-center `}
            >
              <div className="flex flex-col gap-gap-sm items-center justify-center">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="w-graphic-width-md h-graphic-rectangle-height-md"
                />
                <p className="text-text-primary text-font-sm font-normal">
                  No data found.
                </p>
                {clearParameterVisibility ? (
                  <div>
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={handleClearParams}
                      enabledTextColor="var(--text-primary)"
                    />
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldForceRequestViewAll;
